import { PageSection } from "../PageSection";
import { PageHeader } from "../PageHeader";

export const Allergens = () => (
  <PageSection className="policy" id="allergens">
    <PageHeader
      className="policy-header"
      tagline="Allergens"
      subtitle="We keep our menu simple for sensitive guests."
    />

    <div className="policy-content">
      <p>
        The Lil Bougie Foodie does not use eggs or fish in our food.
      </p>
    </div>
  </PageSection>
);
